import React from 'react';
import {Box} from '@material-ui/core';

import calcMuiSpacing, {spacingMap} from './calcMuiSpacing';

const normalizeBoxProps = (props) => {
    const result = {...props};
    const customSpacingKeys = Object.keys(spacingMap);

    Object.keys(props).forEach((propKey) => {
        if (customSpacingKeys.includes(props[propKey])) {
            result[propKey] = calcMuiSpacing(props[propKey]);
        }
    });

    return result;
}

export default function CustomBox({style, ...props}) {
    return (
        <Box
            style={{ width: '100%', ...style}}
            {...normalizeBoxProps(props)}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/grid/CustomBox.jsx